import { up } from 'styled-breakpoints'
import styled from 'styled-components'

import theme from '~/truck/theme'

export const Container = styled.div`
  background-color: ${theme.colors.white};
  display: flex;
  flex-direction: column;
  max-width: unset;
  min-height: 100vh;
  padding: ${theme.spacing.cozy * 4}px;

  > *:not(:last-child) {
    margin-bottom: ${theme.spacing.relaxed}px;
  }

  ${up('lg')} {
    margin: 0 auto;
    max-width: ${theme.spacing.cozy * 120}px;
  }
`
